import { render } from "./ChangeLanguageDropdown.vue?vue&type=template&id=110386f0"
import script from "./ChangeLanguageDropdown.vue?vue&type=script&lang=js"
export * from "./ChangeLanguageDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__